module.exports = __webpack_public_path__ + "img/credential-3.e6efd258.png";